import { supabase } from '../supabaseClient';
import { Workspace } from '../types/domain';
import { notifySchoolProgramMutation } from '../utils/schoolDataCacheVersion';

const SCHOOL_KEY = 'curriculumplanner-school-id';

export async function ensureSchoolContext(): Promise<Workspace> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user?.id) {
    throw new Error('로그인이 필요합니다.');
  }

  const meta = user.user_metadata ?? {};
  const defaultName =
    (typeof meta.full_name === 'string' && meta.full_name.trim()) ||
    (typeof meta.name === 'string' && meta.name.trim()) ||
    '개인 워크스페이스';

  const { data: existing, error: existingError } = await supabase
    .from('workspaces')
    .select('id, name, created_at')
    .eq('id', user.id)
    .maybeSingle();

  if (existingError) {
    throw new Error(existingError.message);
  }

  if (existing) {
    window.localStorage.setItem(SCHOOL_KEY, existing.id);
    return existing as Workspace;
  }

  const { data: created, error } = await supabase
    .from('workspaces')
    .insert({
      id: user.id,
      name: defaultName,
      created_by: user.id,
      updated_at: new Date().toISOString(),
    })
    .select('id, name, created_at')
    .single();

  if (error || !created) {
    throw new Error(error?.message ?? '워크스페이스를 준비하지 못했습니다.');
  }

  window.localStorage.setItem(SCHOOL_KEY, created.id);
  return created as Workspace;
}

export async function updateSchoolName(workspaceId: string, name: string): Promise<void> {
  const { error } = await supabase
    .from('workspaces')
    .update({ name, updated_at: new Date().toISOString() })
    .eq('id', workspaceId);

  if (error) {
    throw new Error(error.message);
  }
  await notifySchoolProgramMutation(workspaceId, ['workspaceProfile']);
}

